import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export const MyCalendarRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ spaceKey }: { spaceKey: any }): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				spaceKey: any;
			};
		};
		MainLayout: {
			spaceKey: any;
		};
	};
} = (): React.JSX.Element => {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.MY_CALENDARS} />;
};

MyCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'myCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		spaceKey,
	},
});
